/** Indian FSSAI-style veg / non-veg marker */

export type FoodTypeValue = "veg" | "non-veg" | "unknown";

export const resolveFoodType = (
  foodType?: string | { name?: string } | null
): FoodTypeValue => {
  const name =
    typeof foodType === "string"
      ? foodType
      : foodType?.name || "";
  const normalized = name.trim().toLowerCase();

  if (!normalized) return "unknown";

  if (
    normalized.includes("non") ||
    normalized.includes("nonveg") ||
    normalized.includes("non-veg") ||
    normalized.includes("egg") ||
    normalized === "nv"
  ) {
    return "non-veg";
  }

  if (
    normalized.includes("veg") ||
    normalized.includes("vegetarian") ||
    normalized === "v"
  ) {
    return "veg";
  }

  return "unknown";
};

type FoodTypeIconProps = {
  foodType?: string | { name?: string } | null;
  size?: number;
  className?: string;
};

const FoodTypeIcon = ({
  foodType,
  size = 14,
  className = "",
}: FoodTypeIconProps) => {
  const type = resolveFoodType(foodType);

  if (type === "unknown") return null;

  const color = type === "veg" ? "#0B8A3D" : "#D32F2F";

  return (
    <span
      className={`inline-flex items-center justify-center shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        border: `1.5px solid ${color}`,
      }}
      title={type === "veg" ? "Vegetarian" : "Non-Vegetarian"}
      aria-label={type === "veg" ? "Vegetarian" : "Non-Vegetarian"}
      role="img"
    >
      <span
        style={{
          width: Math.max(4, size * 0.45),
          height: Math.max(4, size * 0.45),
          borderRadius: "50%",
          backgroundColor: color,
        }}
      />
    </span>
  );
};

export default FoodTypeIcon;
